import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import state from './state'
import mutations from './mutations'
import actions from './actions'

import clients from './modules/clients'
import projects from './modules/projects'
import tasks from './modules/tasks'
import logs from './modules/logs'
import users from './modules/users'
import appBuilds from './modules/app-builds'
import filters from './modules/filters'
import notifications from './modules/notifications'
import tags from './modules/tags'

/**
 * Vuex Config - The App's shared state and state mutators
 */
export default new Vuex.Store({
  state: { ...state },
  mutations,
  actions,
  modules: {
    clients,
    projects,
    tasks,
    logs,
    users,
    appBuilds,
    filters,
    notifications,
    tags
  },
  plugins: [
    createPersistedState()
    // @TODO: re-enable the following inclusion-only paths if users get cache storage errors.
    /* createPersistedState({
      paths: [ // Only persist the following items
        'accessToken',
        'users.currentUser'
      ]
    }) */
  ]
})
